import { ChangeDetectionStrategy, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

@Component({
  selector: 'grabbill-client-html-preview',
  templateUrl: './html-preview.component.html',
  styleUrls: ['./html-preview.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HtmlPreviewComponent implements OnDestroy {
  _isOnLoad = false;
  _html!: string;

  @Input('html')
  set html(value: string) {
    this._html = value;

    if (this._isOnLoad) {
      this.setIframeReady(this.iframe, this._html!);
    }
  }

  @ViewChild('iframe') iframe!: ElementRef;

  onLoad() {
    this._isOnLoad = true;
    this.setIframeReady(this.iframe, this._html!);
  }

  private setIframeReady(iframe: ElementRef, html: string): void {
    if (iframe) {
      const iframeElement = iframe.nativeElement;
      const win: Window = iframeElement.contentWindow;

      const doc: Document = win.document;
      doc.open();

      let processedHtml = html || '';
      if (typeof window !== 'undefined' && window.location && window.location.origin) {
        const origin = window.location.origin;
        processedHtml = processedHtml
          .replace(/https?:\/\/localhost:\d+\/assets\//gi, `${origin}/assets/`)
          .replace(/src=(["'])(?:\.\/|\/)?assets\//gi, `src=$1${origin}/assets/`)
          .replace(/url\((['"]?)(?:\.\/|\/)?assets\//gi, `url($1${origin}/assets/`);
      }

      doc.write(processedHtml);
      doc.close();

      // Prevent link clicks inside iframe preview from navigating or hijacking parent router
      try {
        const anchors = doc.querySelectorAll('a');
        anchors.forEach((a) => {
          a.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
          });
        });
      } catch (e) {
        // ignore iframe security exceptions
      }

      // delay to wait image loaded
      setTimeout(() => {
        if (iframeElement.contentWindow && iframeElement.contentWindow.document.body) {
          iframeElement.width = iframeElement.contentWindow.document.body.scrollWidth;
          iframeElement.height = iframeElement.contentWindow.document.body.scrollHeight;
        }
      }, 500);
    } else {
      setTimeout(() => {
        this.setIframeReady(this.iframe, this._html!);
      }, 500);
    }
  }

  ngOnDestroy(): void {}
}
